// src/Pages/Events.jsx
import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme, Typography, Link } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link as RouterLink } from "react-router-dom";

import pic_1 from "./Photographies/photography/events/backstreetnoise240525-theneue.png";
import pic_2 from "./Photographies/photography/events/cafexx240607.jpg";
import pic_3 from "./Photographies/photography/events/attheedge.gif";
import pic_4 from "./Photographies/photography/events/ebullition_1.png";
import pic_5 from "./Photographies/photography/events/korso_affiche_a3.png";
import pic_6 from "./Photographies/photography/events/boogienight.jpg";
import pic_7 from "./Photographies/photography/events/260109-dfmldn.jpg";
import pic_8 from "./Photographies/photography/events/bday26.jpg";
import pic_9 from "./Photographies/photography/events/NODE_08.08.jpg";
import pic_10 from "./Photographies/photography/events/countryforoldmen.jpg";


import Footer from "./Footer.jsx";
import "./styles.css";

import { getUpcoming } from "../data/events";

export default function Events() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: { fontSize: "3rem", fontWeight: 200 },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        lineHeight: 1.5,
        [base.breakpoints.down("sm")]: {
          fontSize: "1.25rem",
          fontWeight: 300,
        },
      },
    },
  });

  const isDesktop = useMediaQuery("(min-width:600px)");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const imageStyle = {
    width: "100%",
    height: "auto",
    maxWidth: "100%",
  };

  const containerStyle = {
    width: isDesktop ? "35vw" : "80vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    marginTop: "2vw",
  };

  const upcomingEvents = getUpcoming();

  const pastEvents = [
    { pic: pic_10, link: "https://www.instagram.com/p/DcTvnPbjhCq/" },
    { pic: pic_9, link: "https://www.kraftfeld.ch/de/programm/1770/node-amygdala-zuerich-sven-busato-winti-i-date-models-fribourg.html" },
    { pic: pic_8, link: null },
    { pic: pic_7, link: "https://www.soundcloud.com/dfmldn" },
    { pic: pic_6, link: "https://www.instagram.com/p/DNdgKO-K7zj/" },
    { pic: pic_5, link: "https://www.instagram.com/p/DKZibZJKJSt/" },
    { pic: pic_4, link: "https://www.instagram.com/p/DKZibZJKJSt/" },
    { pic: pic_3, link: "https://www.instagram.com/p/DF-A8ZSNJr2/" },
    { pic: pic_2, link: null },
    { pic: pic_1, link: "https://www.instagram.com/p/C7eR-ETtvfS/" },
  ];

  const mobileFluid = "clamp(1.15rem, 4.8vw, 1.4rem)";

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="start"
        minHeight="100vh"
        marginTop="5vh"
        maxWidth="100vw"
        pb="10vh"
      >
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          maxWidth="100vw"
        >
          {/* Title */}
          <Grid item xs={12} sx={{ mb: "5vh" }}>
            <Typography
              variant="h1"
              component={RouterLink}
              to="/"
              sx={{
                color: "inherit",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              // events
            </Typography>
          </Grid>

          {/* // upcoming */}
          <Grid
            item
            xs={12}
            sx={{
              width: isDesktop ? "35vw" : "80vw",
              textAlign: "left",
              mt: 0,
              mb: "5vh",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Helvetica",
                fontSize: { xs: "1.6rem", sm: "2.2rem" },
                fontWeight: { xs: 300, sm: 200 },
              }}
            >
              <b>// upcoming</b>
            </Typography>
          </Grid>

          {/* Upcoming gigs */}
          <Grid
            item
            sx={{
              width: isDesktop ? "35vw" : "80vw",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {upcomingEvents.length === 0 ? (
              <Typography variant="body1" sx={{ opacity: 0.8 }}>
                no bookings for the time being <br></br> (✿◠‿◠)
              </Typography>
            ) : (
              upcomingEvents.map((event, idx) => (
                <Typography
                  key={idx}
                  variant="body1"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                    width: "100%",
                    flexWrap: "wrap",
                    rowGap: 0.5,
                    fontSize: isMobile ? "1.25rem" : "1.25rem",
                    "& > span:first-of-type": {
                      flex: isMobile ? "0 0 45%" : "0 0 35%",
                      minWidth: 0,
                    },
                    "& > span:last-of-type": {
                      flex: isMobile ? "1 1 55%" : "1 1 65%",
                      minWidth: 0,
                      textAlign: "right",
                      overflowWrap: "anywhere",
                    },
                  }}
                >
                  <span>{event.date}</span>
                  <span>
                    {event.link ? (
                      <Link
                        href={event.link}
                        target="_blank"
                        rel="noopener"
                        underline="hover"
                      >
                        {event.name}
                      </Link>
                    ) : (
                      event.name
                    )}{" "}
                    ({event.city})
                  </span>
                </Typography>
              ))
            )}
          </Grid>

          {/* // past */}
          <Grid
            item
            xs={12}
            sx={{
              width: isDesktop ? "35vw" : "80vw",
              textAlign: "right",
              mt: "5vh",
              mb: "1vh",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Helvetica",
                fontSize: { xs: "1.6rem", sm: "2.2rem" },
                fontWeight: { xs: 300, sm: 200 },
              }}
            >
              <b>// past</b>
            </Typography>
          </Grid>

          {/* Past posters */}
          {pastEvents.map((event, index) => (
            <Grid key={`past-${index}`} item xs={12} style={containerStyle}>
              {event.link ? (
                <a href={event.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={event.pic}
                    alt={`Past Event Poster ${index + 1}`}
                    style={{ ...imageStyle, cursor: "pointer" }}
                  />
                </a>
              ) : (
                <img
                  src={event.pic}
                  alt={`Past Event Poster ${index + 1}`}
                  style={{ ...imageStyle, cursor: "default" }}
                />
              )}
            </Grid>
          ))}
        </Grid>
      </Box>
      <Footer fixed />
    </ThemeProvider>
  );
}
